export enum Direction {
  Asc = "asc",
  Desc = "desc",
}
